// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 21:00:47

export default {
  "id": "vex-x3m-2",
  "slug": "vex-x3m-2",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/faf4cfc80f8049f78e1ade958e5332a4-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/faf4cfc80f8049f78e1ade958e5332a4/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Vex X3M 2",
      "description": "Building on the classic Vex experience, VEX X3M2 introduces intense levels packed with new hazards and mechanics. New features like kite gliding let you soar over gaps, while teleportation portals help you navigate tricky sections. Floating platforms and shifting obstacles keep you on your toes, making every race an unpredictable thrill ride.\nEarn stars to unlock high-performance bike skins and conquer each track in easy and hard mode to prove yourself as the ultimate Vex champion!\n",
      "instructions": "Press up (or W) to accelerate, use left (or A) and right (or D) to tilt your bike and press backwards (or S) to brake. Look at your surroundings and pay attention to all the traffic signs! Good luck!",
      "genres": [
        "Racing & Driving"
      ],
      "tags": [
        "bike",
        "biker",
        "motercycle",
        "stickman"
      ]
    },
    "zh-CN": {
      "title": "Vex X3M 2",
      "description": "在经典VEX体验的基础上，VEX X3M2推出了充满新危险和机制的紧张关卡。新功能如风筝滑翔让您飞跃缺口，而传送门则帮助您穿越复杂区域。漂浮平台和移动障碍让您时刻保持警惕，使每一次比赛都成为一场不可预测的刺激之旅。\n赚取星星来解锁高性能自行车皮肤，并在简单和困难模式下征服每条赛道，证明自己是终极VEX冠军！",
      "instructions": "向上（或按W）加速，使用左（或按A）和右（或按D）倾斜自行车，向后（或按S）刹车。观察周围环境，注意所有交通标志！祝你好运！",
      "genres": [
        "赛车与驾驶"
      ],
      "tags": [
        "自行车",
        "骑手",
        "摩托车",
        "stickman（小人物）"
      ]
    },
    "zh-TW": {
      "title": "惡魔X3M 2",
      "description": "在經典的VEX體驗上進行建構，VEX X3M2引進了充滿新危險和機制的強烈關卡。新功能如滑翔風筝讓你翱翔在縫隙之上，而傳送門則幫助你通過複雜的地帶。浮動平台和移動的障礙物讓你保持警惕，使得每一次比賽都成為一場不可預測的刺激之旅。\n獲得星星來解鎖高性能單車外殼，並在簡單和困難模式下征服每條軌道，以證明你是最終的VEX冠軍！",
      "instructions": "按上鍵（或W）以加速，使用左鍵（或A）和右鍵（或D）來傾斜你的單車，並按後退鍵（或S）以煞車。注意你的周圍環境，並留意所有交通標誌！祝你好運！",
      "genres": [
        "賽車與駕駛"
      ],
      "tags": [
        "單車",
        "單車骑士",
        "機車",
        "小木人"
      ]
    },
    "zh-HK": {
      "title": "Vex X3M 2",
      "description": "建立在經典的VEX體驗之上，VEX X3M2推出充滿新危險和機制的強烈關卡。新功能如滑翔风筝讓你可以翱翔於缺口之上，而傳送門則幫助你通過棘手的段落。浮動平台和移動障礙讓你保持警惕，讓每一場賽事都成為一場不可預測的刺激之旅。\n獲得星星來解鎖高性能自行車外殼，並以簡單和困難模式征服每條跑道，以證明你是無敵的VEX冠軍！",
      "instructions": "按上鍵（或 W）加速，使用左鍵（或 A）及右鍵（或 D）操控單車傾斜，按後鍵（或 S）制動。留意周圍環境，並注意所有交通標誌！祝你好運！",
      "genres": [
        "賽車及駕駛"
      ],
      "tags": [
        "單車",
        "騎士",
        "機車",
        "立體人"
      ]
    },
    "ja": {
      "title": "ベクスX3M2",
      "description": "クラシックなVEXエクスペリエンスを発展させ、VEX X3M2は新たな危険とメカニクスが詰まった激しいレベルを導入しています。キートレーニングのような新しい機能で、ギャップを飛び越えられるようになり、テレポートポータルで難しい場所を乗り越えることができます。浮遊プラットフォームや移動する障害物が足を止めさせず、それぞれのレースが予測不能なスリリングな旅になります。\n\n星を獲得してハイパフォーマンスのバイクスキンを解除し、簡単と難しいモードでそれぞれのトラックを征服して、究極のVEXチャンピオンとして自分自身を証明しましょう！",
      "instructions": "上（またはW）を押して加速し、左（またはA）と右（またはD）を使用して自転車を傾けること、後ろ（またはS）を押してブレーキをかけます。周囲を見て、すべての交通標識に注意してください！頑張ってください！",
      "genres": [
        "レーシング & ドライビング"
      ],
      "tags": [
        "自転車",
        "バイカー",
        "オートバイ",
        "スティックマン"
      ]
    },
    "ko": {
      "title": "벡스 X3M 2",
      "description": "클래식 Vex 경험을 기반으로, VEX X3M2는 새로운 위험과 기계를 포함한 강력한 레벨을 선보입니다. 키트 글라이딩과 같은 새로운 기능은 구불구불한 구간을 넘나들게 하고, 텔레포트 포트럴은 복잡한 구간을 탐험하는 데 도움을 줍니다. 떠있는 플랫폼과 변하는 장애물은 매번 레이스를 예측할 수 없는 스릴러 rid에 만들어줍니다.\n\n별을 따서 고성능 바이크 스킨을 해금하고, 각 트랙을 쉬운 모드와 어려운 모드로 완성하여 최종 Vex 챔피언으로서의 자신을 입증하세요!",
      "instructions": "위쪽(또는 W)으로 가속, 왼쪽(또는 A)과 오른쪽(또는 D)으로 자전거를 기울이고, 뒤쪽(또는 S)으로 브레이크를 누르세요. 주변을 주의 깊게 보고 모든 교통 신호에 유의하세요! 성공하길 바랍니다!",
      "genres": [
        "레이싱 & 드라이빙"
      ],
      "tags": [
        "바이크",
        "바이커",
        "모터사이클",
        "스틱맨"
      ]
    },
    "fr": {
      "title": "Vex X3M 2",
      "description": "Construit sur l'expérience classique de Vex, VEX X3M2 propose des niveaux intenses chargés de nouveaux dangers et mécanismes. De nouvelles fonctionnalités comme le glissement en cerf-volant vous permettent de survoler les brèches, tandis que les portails de téléportation aident à naviguer dans les sections délicates. Des plateformes flottantes et des obstacles mobiles vous tiennent en haleine, rendant chaque course une aventure imprévisible et palpitante.\n\nGagnez des étoiles pour déverrouiller des skins de vélos de haute performance et terminez chaque piste en mode facile et difficile pour vous montrer comme le champion ultime de Vex !",
      "instructions": "Appuyez sur haut (ou W) pour accélérer, utilisez la touche gauche (ou A) et droite (ou D) pour incliner votre vélo et appuyez en arrière (ou S) pour freiner. Regardez autour de vous et soyez attentif à tous les panneaux de signalisation ! Bonne chance !",
      "genres": [
        "Courses et conduite"
      ],
      "tags": [
        "vélo",
        "cycliste",
        "motocyclette",
        "stickman"
      ]
    }
  }
};
